import cameraSvg from '../../../../images/common/camera.svg'
import hospitalSvg from '../../../../images/common/hospital.svg'
import phoneSvg from '../../../../images/common/phone.svg'
import clipboardCheckSvg from '../../../../images/common/clipboard-check.svg'

import { ASYNCHRONOUS_VISIT_METHOD } from '../../../../utils/getVisitTypeLabel'
import { VisitMethodOptions, VisitMethods } from './VisitMethods'

const sharedProps = {
  style: {
    width: 24,
    height: 24,
  },
}

export const getVisitMethodIconProps = (
  methodOrOption: VisitMethodOptions | VisitMethods | typeof ASYNCHRONOUS_VISIT_METHOD,
) => {
  if (methodOrOption === ASYNCHRONOUS_VISIT_METHOD) {
    return { ...sharedProps, src: clipboardCheckSvg, alt: 'online visit icon' }
  }

  switch (methodOrOption) {
    case VisitMethods.VIDEO:
    case VisitMethodOptions.VIDEO:
      return { ...sharedProps, src: cameraSvg, alt: 'video visit icon' }
    case VisitMethods.CALL:
    case VisitMethodOptions.PHONE:
      return { ...sharedProps, src: phoneSvg, alt: 'phone visit icon' }
    case VisitMethods.INPERSON:
    case VisitMethodOptions.IN_PERSON:
      return { ...sharedProps, src: hospitalSvg, alt: 'in-person visit icon' }
    default:
      throw new Error(`Invalid visit method/method option: ${methodOrOption satisfies never}`)
  }
}
